export function buf2hex(buffer: ArrayBuffer) { // buffer is an ArrayBuffer
    // @ts-ignore
    return [...new Uint8Array(buffer)]
        .map(x => x.toString(16).padStart(2, '0'))
        .join('');
}
